import { render, staticRenderFns } from "./dyrsPage.vue?vue&type=template&id=6cc27724"
import script from "./dyrsPage.vue?vue&type=script&lang=js"
export * from "./dyrsPage.vue?vue&type=script&lang=js"
import style0 from "./dyrsPage.vue?vue&type=style&index=0&id=6cc27724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports